import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink } from 'reactstrap';

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

class ContactUs extends Component {
  render() {
    	return (
      <div className="app align-items-center mcg">

        <span className="frontbk" style={{zIndex:"0"}} />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
            <Card className="mb-0">
            <Menu/>
              <CardHeader  className="titlehead">
                  <h1 className="mb-0 my-2">Contact Us</h1>
                  <p className="text-center mb-0"></p>
              </CardHeader>
              <CardBody className="pageSetting login-form py-0">
                
                <Row>
                  <Col lg="12" className="leftbox pt-0">
                    
                    <div className="rb-inner" style={{ paddingTop: '2rem' }}>
                      <h1 className="mb-0 my-2"></h1>

<div className="tips-msg pb-0">
                        If you are having problems or have questions please send us an email but be sure to include your name and as much detail as you can about the problem. <br />Please  send to support@askmyphone.net
                      </div>

                      

                    </div>
                  </Col>
                  
                </Row>
              </CardBody>

            </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"3"}}>
          <CRNote/>
        </Container>
      </div>
    );
  }
}

export default ContactUs;


// WEBPACK FOOTER //
// ./src/views/Pages/ContactUs/ContactUs.js